import {
  Column,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  GridComponent,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  ToolbarItems,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Group,
  Resize,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import 'react-toastify/dist/ReactToastify.css';
import 'react-jquery-plugin';
import { all_information, loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  createTeam,
  getTeams,
  teamDelete,
  teamUpdate,
} from '../../services/tradeperson/team';
import { upperCase } from 'lodash';
interface IProps {}
interface IState {
  TeamsData: any;
  hideDialog: boolean;
  inputName: any;
  inputDescription: any;
  pickedTeamId: any;
  hideDialogDelete: boolean;
  hideEditDialog: boolean;
}
export default class Teams extends React.Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  private ElementType: any = ['Shift', 'Exception'];
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private time: Date = new Date('8/3/2017 10:00');
  constructor(props: IProps) {
    super(props);

    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTeam();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsEdit = [
      {
        click: () => {
          this.editTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideEditDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.createTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      hideEditDialog: false,
      hideDialogDelete: false,
      pickedTeamId: '',
      inputName: '',
      inputDescription: '',
      TeamsData: [],
      hideDialog: false,
      // @ts-ignore
      update: false,
    };
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    // @ts-ignore
    if (this.state.update) {
      getTeams().then((result) => {
        this.setState({ TeamsData: result.data });
        // @ts-ignore
        this.setState({ update: true });
      });
    }
  }
  componentDidMount() {
    this.getTheTeams();
  }
  getTheTeams() {
    getTeams().then((result) => {
      this.setState({ TeamsData: result.data });
    });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({ hideDialog: true });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const id = this.grid.getSelectedRecords()[0].team_id;
        const name = this.grid.getSelectedRecords()[0].team_code;
        const desc = this.grid.getSelectedRecords()[0].description;

        this.setState({
          inputName: name,
          inputDescription: desc,
        });

        this.dialogOpenEdit();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.dialogOpenDelete();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
  }
  private dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogOpenEdit(): void {
    this.setState({ hideEditDialog: true });
  }
  private dialogCloseEdit(): void {
    this.setState({
      hideEditDialog: false,
    });
  }
  filterTeamDesc(t_code: any) {
    if (this.state.TeamsData.length > 1) {
      let teamId = this.state.TeamsData.filter((item: any) => {
        return item.teamCode === t_code;
      });
      return teamId[0].description;
    } else {
      return '';
    }
  }

  editTeam() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    var teamCode = this.state.inputName;
    var description = this.state.inputDescription;
    if (teamCode === '') {
      Message.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (description === '') {
      Message.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: description,
      team_id: theElements[0].team_id,
    };
    teamUpdate(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Edited successfully...');
        this.dialogClose();
        this.getTheTeams();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });

    this.dialogCloseEdit();
  }
  deleteTeam() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    let obj = {
      team_id: theElements[0].team_id,
    };
    teamDelete([theElements[0].team_id])
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.dialogClose();
        this.getTheTeams();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.dialogCloseDelete();
  }
  async createTeam() {
    var teamCode = this.state.inputName;
    var description = this.state.inputDescription;
    if (teamCode === '') {
      Message.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (description === '') {
      Message.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }
    const res = await getTeams();
    let teams: { team_code: string; description: string }[] = res.data;
    loadingShow(true);
    const teamExists = teams.some(
      (eachteam) => upperCase(eachteam.team_code) === upperCase(teamCode)
    );

    if (teamExists) {
      Message.error('Same Team Already Exist');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: description,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };
    createTeam(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');
        this.getTheTeams();
        this.dialogClose();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
      });
    loadingShow(false);
  }
  render() {
    return (
      <div>
        <GridComponent
          dataSource={this.state.TeamsData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-270px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines={'Both'}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='team_code'
              headerText='Team Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Team Description'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>

        {this.state.hideEditDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogAddTeam'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideEditDialog}
            width={'400px'}
            header='Team Editing'
            buttons={this.buttonsEdit}
            open={this.dialogOpenEdit.bind(this)}
            close={this.dialogCloseEdit.bind(this)}
          >
            <div className='row mb-3'>
              <div className='col-md-3'>Team Name:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputName: e.value });
                  }}
                  value={this.state.inputName}
                  placeholder='Enter Name'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Description:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputDescription: e.value });
                  }}
                  value={this.state.inputDescription}
                  placeholder='Enter Description'
                />
              </div>
            </div>
          </DialogComponent>
        ) : null}
        {this.state.hideDialogDelete ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogDelete}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={this.dialogOpenDelete.bind(this)}
            close={this.dialogCloseDelete.bind(this)}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        <div className='control-pane-dialogAdd'>
          <div
            id='targetElementAddTeam'
            className='col-lg-12 defaultDialogAddTeam dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogAddTeam'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                width={'400px'}
                header='Team'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='row mb-3'>
                  <div className='col-md-3'>Team Name:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputName: e.value });
                      }}
                      placeholder='Enter Name'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Description:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputDescription: e.value });
                      }}
                      placeholder='Enter Description'
                    />
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
